import {
    createContext,
    useContext,
    useCallback,
    useEffect,
    useState,
} from 'react';

import mockedMaterials from '../../mock_data/materials.json';

const Context = createContext();

const Provider = ({ children }) => {
    const [all, setAll] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const getAll = useCallback(async () => {
        setIsLoading(true);
        setAll(mockedMaterials);
        setIsLoading(false);
    });

    useEffect(() => {
        getAll().catch((err) => console.error(err));
    }, []);

    return (
        <Context.Provider
            value={{
                all,
                isLoading,
            }}
        >
            {children}
        </Context.Provider>
    );
};

export const useMaterialCtx = () => {
    return useContext(Context);
};

export default Provider;
